import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import {
  FileInput,
  form,
  Form as AppForm
} from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import { importLineItems } from "MODULES/Consignments/actions";
import { Warning } from "MODULES/shared/components";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";

const formName = "importConsignments";

function Form(props) {
  const fileLink =
    "https://info-trader-assets.s3.us-east-2.amazonaws.com/public/InfoTrader_Consignment_Import_Template_v3.csv";
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Warning>
            Please use the following column headers for the Consignment import:
            <br />
            <br />
            <strong>part_number</strong> (required field: unique identifier for
            the part).
            <br />
            <strong>serial</strong> (optional field).
            <br />
            <strong>cond</strong> (required field: acceptable codes: NE, OH, SV,
            BT, SV TOOLING, AR, BR. Uppercase or lowercase).
            <br />
            <strong>qty</strong> (required field: quantity).
            <br />
            <strong>tag_date</strong> (optional field: can be left blank).
            <br />
            <strong>tagged_by</strong> (optional field: free text).
            <br />
            <strong>trace_to</strong> (optional field: maximum of 20 characters;
            free text).
            <br />
            <strong>trace_type</strong> (optional field: free text).
            <br />
            <strong>dom</strong> (optional field: can be left blank).
            <br />
            <strong>wh</strong> (optional field: can be left blank).
            <br />
            <strong>location</strong> (optional field: can be left blank).
            <br />
            <strong>note</strong> (optional field: free text).
            <br />
            <br />
            Ensure the import file is in .csv format.
          </Warning>
        </FormRow>
        <FormRow>
          <Col md={8}>
            <Field
              name="file"
              component={FileInput}
              label="Upload Attachment"
              required
            />
          </Col>
        </FormRow>
        {fileLink && (
          <FormRow>
            <Col md={8} mdOffset={2}>
              <a href={fileLink} target="_blank" rel="noopener noreferrer">
                Template
              </a>
            </Col>
          </FormRow>
        )}
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(undefined, dispatch => ({
  onSubmit: data => dispatch(importLineItems(data))
}))(
  form({
    form: formName
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/Consignments/Detail/ImportConsignments/Form.jsx